<template>
    <div>
        <Toast/>
        <div class="grid">
            <div class="field col-6">
                <label for="sProductName">Selecciona la impresora para tickets:</label>
                <Dropdown 
                    :options="printers"
                    optionLabel="label"
                    v-model="selectedPrinter"
                    placeholder="Selecciona una impresora"
                    @change="onPrinterChange">
                </Dropdown>
            </div>
            <div class="field col-6">
                <label >Presione si esta computadora no tiene una impresora de tickets</label>
                <Button label="Quitar Impresora"  @click="removeConfig()"/>
            </div>

        </div>

        
        <div class="p-dialog-footer">
            <Button label="Cerrar" icon="pi pi-times" class="p-button-text" @click="Cancel"/>
        </div>          
    </div>
</template>

<script>
/* eslint-disable */


export default {
	data() {
		return {
            selectedPrinter: null,
            printers: [],

		}
	},
	created() {
	},
	async mounted() {
        await this.getPrinters();
        const encrypted = localStorage.getItem(STORAGE_KEY_TICKET_PRINTER);
        
        if (encrypted) {
            try {
                const bytes = cryptoJs.AES.decrypt(encrypted, SECRET_KEY);
                const decrypted = bytes.toString(cryptoJs.enc.Utf8);
                if (decrypted && this.printers.some(p => p.value === decrypted)) {
                    this.selectedPrinter = {label: decrypted, value: decrypted};
                }
            } catch (e) {
                console.warn('No se pudo obtener la impresora guardada' + e);
            }
        }
	},
	methods: {
        removeConfig(){
            localStorage.removeItem('keyTkPr');
            this.selectedPrinter = null
        },
		async getPrinters() {
            await axios.get(apiPrinter + 'printers', { headers: {
                    'Content-Type': 'application/json'
                } })
            .then( (response) => {
                let resp = response.data;
                this.printers = resp.map(name => ({
                    label: name,
                    value: name
                }));
            } )
            .catch( (error)  => {
                this.showError('Error', 'No se pudo establecer comunicación con el servicio de impresión, por favor verificque el servicio o llame a Soporte Técnico: ' + error)
            } )  
		},
        onPrinterChange(value) {
            console.log('value: ' + JSON.stringify(this.selectedPrinter));
            const selected = this.selectedPrinter.value;
            if (selected) {
                const encrypted = cryptoJs.AES.encrypt(selected, SECRET_KEY).toString();
                localStorage.setItem(STORAGE_KEY_TICKET_PRINTER, encrypted);
            } else {
                localStorage.removeItem(STORAGE_KEY_TICKET_PRINTER);
            }
        },
        Cancel(){
			this.$emit('eventname', false)
		}, 
    }
}
</script>

<style scoped lang="scss">
@import '../../assets/demo/styles/badges.scss';

</style>